import { debug } from 'svelte/internal';
import { constants } from './constants.js';

export function getCommaSeparted(thelist) {
  if (thelist == undefined || thelist == null)
    return '';

  return thelist.map(x => x.name).join(", ");
}

export function getCommaSepartedStringsAsNoBr(thelist) {
  if (thelist == undefined || thelist == null)
    return '';

  return thelist.map(x => '<nobr>' + x + '</nobr>').join(", ");
}

export function getWageGradesForCountry(settings) {

  // Find the highest grade number from Workforce subSection variables
  const workforceSection = settings.subSections ?  settings.subSections.find(s => s.subSectionNameKey === 'Workforce') : null;
  let maxGrade = 7; // default
  
  if (workforceSection && workforceSection.variables) {
    const gradeNumbers = workforceSection.variables
      .map(v => {
        const match = v.nameKey && v.nameKey.match(/WorkersGrade(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      })
      .filter(n => n > 0);
    
    if (gradeNumbers.length > 0) {
      maxGrade = Math.max(...gradeNumbers);
    }
  }

  const grades = [];
  for (let i = 1; i <= maxGrade; i++) {
    grades.push(`Grade${i}`);
  }
  return grades;
}

export function getCommaSepartedStringsAsBr(thelist) {
  if (thelist == undefined || thelist == null)
    return '';

  return thelist.map(x => x + '<br/>').join(" ");
}

var shownalert = true
export function formatNumber(
  amount,
  decimalCount = amount < 1 ? 4 : amount < 5 ? 3 : amount < 1000 ? 2 : 0,
  decimal = ",",
  thousands = ".", valueIf0 = ""
) {
  if (!shownalert) {
    alert('using old formatNumber')

  }
}


export function getCommaSepartedVariables(thelist) {
  if (thelist == undefined || thelist == null)
    return '';
  return thelist.map(x => x.variable.name).join(",");
}

export async function fetchJson(url) {
  const res = await fetch(constants.baseUrl + url);
  const json = await res.json();
  if (res.ok) {
    if (json.Error) {
      alert(json.Message)
      return;
    }
    return json;
  } else {
    alert('Mogelijk was je uitgelogd : an error happened in fetch json! \r\n' + url);
    alert(JSON.stringify(json));
    location.reload();
    throw new Error(json);
  }
}

export async function fetchPlain(url) {
  const res = await fetch(constants.baseUrl + url);
  const text = await res.text();
  if (res.ok) {
    if (text.includes('Error')) {
      var json = JSON.parse(text)
      alert(json.Message)
      return;
    }
    return text;
  } else {
    alert('Mogelijk was je uitgelogd : an error happened in fetch plain! \r\n' + url);
    alert(JSON.stringify(json));
    location.reload();

    throw new Error(json);
  }
}
export function sortByField(prop) {
  return function (a, b) {
    if (a[prop] > b[prop])
      return 1;
    if (a[prop] < b[prop])
      return -1
    return 0
  }
}

export async function fetchJsonWithMethod(method, url, params) {
  try {
    const res = await fetch(constants.baseUrl + url, {
      method: method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params)
    });
    var json = await res.json();
    if (json.Error) {
      alert(json.Message)
      return;
    }
    return json;

  } catch (s) {
    alert('Mogelijk was je uitgelogd : an error happened in fetch json with method! \r\n' + url + '\r\n' + s);
    alert(JSON.stringify(json));
    location.reload();

    throw new Error('an error happened posting data');

  }
}

export function saveAsFile(txt, filename) {
  var blob = new Blob([txt], { type: 'text/plain' })
  const url2 = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url2;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url2);
}

export async function fetchFileWithMethod(method, url, params, filename) {
  try {
    const res = await fetch(constants.baseUrl + url, {
      method: method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params)
    });
    var file = await res.blob();
    const url2 = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url2;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url2);

  } catch (s) {
    alert('Mogelijk was je uitgelogd : an error happened in fetch json with method! \r\n' + url + '\r\n' + s);
    alert(JSON.stringify(json));
    location.reload();

    throw new Error('an error happened posting data');

  }
}
export async function downloadFile(url, filename) {
  fetch(constants.baseUrl + url)
    .then(resp => resp.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((s) => {
      alert('Mogelijk was je uitgelogd : An error has happened in download file! \r\n' + url + '\r\n' + s)
    });
}

export function generateUUID() { // Public Domain/MIT
  var d = new Date().getTime();//Timestamp
  var d2 = (performance && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16;//random number between 0 and 16
    if (d > 0) {//Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

export function sentenceCase(txt, makerestlower=true) {
  if(makerestlower){

  
  txt = txt.toLowerCase();
}
  if (!txt || txt.length == 0) return txt;

  let ret = txt.substr(0, 1).toUpperCase();
  if (txt.length > 1) {
    ret += txt.substring(1);
  }
  return ret;
}